import React from 'react';
import { Box } from '@mui/material';

const Logo = ({ variant = 'default' }) => {
  const isCompact = variant === 'compact';
  const iconSize = isCompact ? 54 : 72; // 50% bigger again (now 2.25x original)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
          '& img': {
            transform: 'scale(1.1) rotate(5deg)',
          },
        },
        '& img': {
          transition: 'transform 0.3s ease',
          width: iconSize,
          height: iconSize,
          objectFit: 'contain',
        },
      }}
    >
      <img 
        src={isCompact ? '/logo192.png' : '/logo512.png'} 
        alt="GymRat Logo"
      />
    </Box>
  );
};

export default Logo; 